import React, { useState, useRef, useMemo, useCallback, useEffect } from "react";
import TablePagination from '@material-ui/core/TablePagination';
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, MenuItem,
    TableRow, Table,
    TableHead, Select, TextField,
    TableBody, Card, Box,
    TableCell, TableContainer,
    Paper, Typography,
    CircularProgress,
    Chip,
    Avatar,
    Collapse,
    InputAdornment,
   
    Divider,
    Menu,
    IconButton,
    Tooltip,
    Checkbox,
    FormControlLabel,
} from "@material-ui/core";
import ActivityService from "./Locality/Service/activityService";
import SubActivityService from "./Locality/Service/subActivityService";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import { Grid, } from "@material-ui/core";
import { useFormik } from 'formik';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import FilterListIcon from '@material-ui/icons/FilterList';
import CloseIcon from '@material-ui/icons/Close';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import SchoolIcon from '@material-ui/icons/School';
import PersonIcon from '@material-ui/icons/Person';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import GetAppIcon from '@material-ui/icons/GetApp';
import SendIcon from '@material-ui/icons/Send';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { makeStyles } from '@material-ui/core/styles';
import StudentService from "./Locality/Service/studentService";
import ExportExcel from "../../Excelexport";
const useStyles = makeStyles((theme) => ({
    pageHeader: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    pageTitle: {
        fontWeight: 700,
        fontSize: '1.9rem',
        color: '#0f2d4d',
        lineHeight: 1.2,
    },
    pageSubtitle: {
        color: '#6b7280',
        fontSize: '0.9rem',
        marginTop: 2,
    },
    primaryBtn: {
        backgroundColor: '#1769d6',
        color: '#fff',
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        padding: '8px 18px',
        boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
        '&:hover': { backgroundColor: '#125bbd' },
    },
    darkBtn: {
        backgroundColor: '#0f2d4d',
        color: '#fff',
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        padding: '8px 18px',
        '&:hover': { backgroundColor: '#0b2238' },
    },
    noteBanner: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2),
        borderRadius: 12,
        backgroundColor: '#eef4ff',
        border: '1px solid #d6e4ff',
        marginBottom: theme.spacing(2),
    },
    noteIconWrap: {
        width: 28,
        height: 28,
        borderRadius: '50%',
        backgroundColor: '#1769d6',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    filtersCard: {
        borderRadius: 14,
        border: '1px solid #e6eaf0',
        boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    filtersTopRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
    },
    filtersChip: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '6px 12px',
        borderRadius: 8,
        border: '1px solid #d9dee7',
        backgroundColor: '#f7f9fc',
        cursor: 'pointer',
        fontWeight: 600,
        color: '#0f2d4d',
        userSelect: 'none',
    },
    countBadge: {
        backgroundColor: '#fff',
        color: '#1769d6',
        border: '1px solid #cfe0fb',
        borderRadius: 12,
        padding: '1px 10px',
        fontSize: '0.72rem',
        fontWeight: 700,
        marginLeft: 8,
    },
    fieldLabel: {
        fontSize: '0.78rem',
        fontWeight: 600,
        color: '#46566b',
        marginBottom: 6,
        display: 'flex',
        alignItems: 'center',
        gap: 4,
    },
    resetBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        color: '#46566b',
        border: '1px solid #d9dee7',
    },
    uploadBox: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5),
        borderRadius: 10,
        border: '1px dashed #cfd8e6',
        backgroundColor: '#fafbfd',
    },
    sampleLink: {
        color: '#1769d6',
        fontWeight: 600,
        fontSize: '0.85rem',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        textDecoration: 'none',
    },
    tableCard: {
        borderRadius: 14,
        border: '1px solid #e6eaf0',
        boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
        overflow: 'hidden',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        padding: theme.spacing(2),
    },
    iconBtnOutlined: {
        border: '1px solid #d9dee7',
        borderRadius: 8,
        padding: 8,
        color: '#46566b',
    },
    classChip: {
        backgroundColor: '#e8f0fe',
        color: '#1769d6',
        fontWeight: 600,
        borderRadius: 6,
    },
    sectionChip: {
        backgroundColor: '#eef4ff',
        color: '#46566b',
        fontWeight: 600,
        borderRadius: 6,
    },
    studentAvatar: {
        width: 38,
        height: 38,
        backgroundColor: '#eef4ff',
        color: '#1769d6',
    },
}));
export default function StudentDetails(props, history) {
    const tableHeaders = ['First Name', 'Last Name', 'Date Of Birth', 'Age', 'mobileNumber-1', , 'mobileNumber-2', 'UserName', 'Edit', 'Delete'];
    const classes = useStyles();
    const [message, setMessage] = useState("");
    const [teacherList, setTeacherList] = useState([]);
    const [classNameList, setClassNameList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editId, setEditId] = useState(null);
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    const [teacherIdList, setTeacherIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(1000);
    const [file, setFile] = useState(null);
    const fileInputRef = useRef(null);
    const [isUploading, setIsUploading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [viewOpen, setViewOpen] = useState(false);
    const [viewStudent, setViewStudent] = useState(null);
    const [uploadErrorOpen, setUploadErrorOpen] = useState(false);
    const [uploadError, setUploadError] = useState({
        message: "",
        invalidClasses: [],
        allowedClassNames: [],
    });
    const [uploadFailedOpen, setUploadFailedOpen] = useState(false);
    const [uploadFailedDetails, setUploadFailedDetails] = useState([]);
    const [sendingCredentialsBulk, setSendingCredentialsBulk] = useState(false);
    const [credentialsSuccessOpen, setCredentialsSuccessOpen] = useState(false);
    const [credentialsSuccessNames, setCredentialsSuccessNames] = useState([]);
    const [credentialsFailureDetails, setCredentialsFailureDetails] = useState([]);
    const [resetPasswordOpen, setResetPasswordOpen] = useState(false);
    const [resetPasswordStudent, setResetPasswordStudent] = useState(null);
    const [resetPasswordValue, setResetPasswordValue] = useState('');
    const [resetPasswordConfirm, setResetPasswordConfirm] = useState('');
    const [resetPasswordError, setResetPasswordError] = useState('');
    const [resetPasswordSuccess, setResetPasswordSuccess] = useState('');
    const [resetPasswordSaving, setResetPasswordSaving] = useState(false);
    const [resetShowPassword, setResetShowPassword] = useState(false);
    const [sendPasswordToParent, setSendPasswordToParent] = useState(false);

    const canResetParentPassword = useMemo(() => {
        const role = String((JSON.parse(localStorage.getItem('userDetail') || '{}') || {})?.role || '').toUpperCase();
        return role === 'SCHOOLE' || role === 'SUPERADMIN';
    }, []);

    var [studentId, setStudentId] = useState("");
    var [classId, setClassId] = useState("");
    const [addClassList, setAddClassList] = useState([]);
    const [uploadClassId, setUploadClassId] = useState("");
    const [uploadSectionId, setUploadSectionId] = useState("");
    const [uploadSectionList, setUploadSectionList] = useState([]);
    const [addUserPermitionsList, setUserPermitionsList] = useState({ studentDetailsEdit: false, studentDetailsDelete: false });
    const [student, setStudent] = useState({
        classId: '',
        teacherName: '',
        email: '',
        subject: '',
        qualification: '',

        address: '',
        mobileNumber: '',
        attendence: '',
        status: '',
    });
    // ---- Redesigned UI state ----
    const [noteOpen, setNoteOpen] = useState(true);
    const [filtersOpen, setFiltersOpen] = useState(true);
    const [columnMenuAnchor, setColumnMenuAnchor] = useState(null);
    const [actionMenu, setActionMenu] = useState({ anchorEl: null, student: null });
    const [visibleCols, setVisibleCols] = useState({
        admissionNumber: true,
        middleName: true,
        parentMobile: true,
        className: true,
        section: true,
        userName: true,
        parentProfileStatus: true,
        aadharNumber: true,
        address: false,
    });

    const columnConfig = [
        { id: 'admissionNumber', label: 'Admission Number' },
        { id: 'middleName', label: 'Middle Name' },
        { id: 'parentMobile', label: 'Parent Mobile' },
        { id: 'className', label: 'Class' },
        { id: 'section', label: 'Section' },
        { id: 'userName', label: 'User Name' },
        { id: 'parentProfileStatus', label: 'Parent Profile' },
        { id: 'aadharNumber', label: 'Aadhaar Number' },
        { id: 'address', label: 'Address' },
    ];

    const getStudentAadharNo = (student) => {
        const value = String(student?.aadharNo || student?.adharNo || '').trim();
        return value || '—';
    };

    const openActionMenu = (event, student) => setActionMenu({ anchorEl: event.currentTarget, student });
    const closeActionMenu = () => setActionMenu({ anchorEl: null, student: null });

    const activeFilterCount = [uploadClassId, uploadSectionId].filter(Boolean).length;

    const handleResetFilters = () => {
        setUploadClassId('');
        setUploadSectionId('');
        setSearchTerm('');
        setpg(0);
    };

    const headerCellStyle = {
        backgroundColor: '#f4f6fa',
        color: '#46566b',
        fontWeight: 700,
        fontSize: '0.8rem',
        borderBottom: '1px solid #e6eaf0',
    };

    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }

    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }

    const fetchFilteredStudents = useCallback(() => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        if (!userDetails.schooleId) return;

        const keys = {
            schooleId: userDetails.schooleId,
            ...(uploadClassId && { classId: uploadClassId }),
            ...(uploadSectionId && { sectionId: uploadSectionId }),
        };
        StudentService.findStudentList(keys).then((res) => {
            const mapResult = res.map((student) => ({
                ...student,
                fullName: `${student.firstName} ${student.lastName}`,
                userId: student.userId || {},
            }));
            setStudentList(mapResult);
        }).catch(() => {});
    }, [uploadClassId, uploadSectionId]);

    useEffect(() => {
        // getTeacherList();
        // getStudentList();
        getUserPermitionsList();
        getAddClassList();
        return () => {
            setTeacherIdList([]);
            setTeacherList([]);
            setStudentList([]);
            setUserPermitionsList({})
            setAddClassList([]);
        }
    }, []);

    useEffect(() => {
        if (!uploadClassId) {
            setUploadSectionList([]);
            setUploadSectionId("");
            return;
        }
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        SectionService.findSectionList({ schooleId: userDetails.schooleId, classId: uploadClassId, status: true })
            .then((res) => setUploadSectionList(Array.isArray(res) ? res : []))
            .catch(() => setUploadSectionList([]));
        setUploadSectionId("");
    }, [uploadClassId]);

    useEffect(() => {
        setpg(0);
        fetchFilteredStudents();
    }, [fetchFilteredStudents]);

    const handleOpen = () => {
        props.history.push('/app/studentregistration/add')
    };
    const onclick = () => {
        setOpen(true);
    }
    const handleFileChangeFile = (e) => {
        setFile(e.target.files[0]); // Get the selected file
    };

    const handleFileUpload = async () => {
        if (!file) {
            setMessage('Please select a file first.');
            return;
        }

        setIsUploading(true);

        const formData = new FormData();
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        formData.append('excel', file);
        formData.append('schooleId', userDetails.schooleId);
        if (uploadClassId) formData.append('classId', uploadClassId);
        if (uploadSectionId) formData.append('sectionId', uploadSectionId);

        try {
            SubActivityService.studentdRegister('/subactivity/studentregister/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then((res) => {
                const failedDetails = res?.failedDetails && Array.isArray(res.failedDetails) ? res.failedDetails : [];
                if (failedDetails.length > 0) {
                    setUploadFailedDetails(failedDetails);
                    setUploadFailedOpen(true);
                } else {
                    alert("Data Imported Successfully.");
                }
                setFile(null);
                if (fileInputRef.current) fileInputRef.current.value = '';
                fetchFilteredStudents();
                setIsUploading(false);
            }).catch((err) => {
                const data = err?.response?.data;
                let backendMessage = "";
                let invalidClasses = [];
                let allowedClassNames = [];

                if (data && typeof data === "object") {
                    backendMessage = data.message || "";
                    invalidClasses = Array.isArray(data.invalidClasses) ? data.invalidClasses : [];
                    allowedClassNames = Array.isArray(data.allowedClassNames) ? data.allowedClassNames : [];
                } else if (typeof data === "string") {
                    backendMessage = data;
                } else {
                    backendMessage = "Failed to upload. Please check the file format and class names.";
                }

                setUploadError({
                    message: backendMessage,
                    invalidClasses,
                    allowedClassNames,
                });
                setUploadErrorOpen(true);
                setIsUploading(false);
            });


        } catch (error) {
            console.error('Error uploading file:', error);
            setMessage('Failed to upload file.');
            setIsUploading(false);
        }
    };
    const filteredStudents = useMemo(() => {
        const term = searchTerm.toLowerCase();
        return studentList
            .filter((student) =>
                student.fullName?.toLowerCase().includes(term)
                || student.admissionNumber?.includes(searchTerm)
            )
            .sort((a, b) => {
                const nameA = (a.fullName || `${a.firstName || ''} ${a.lastName || ''}`).trim().toLowerCase();
                const nameB = (b.fullName || `${b.firstName || ''} ${b.lastName || ''}`).trim().toLowerCase();
                return nameA.localeCompare(nameB);
            });
    }, [studentList, searchTerm]);

    const getStudentClassName = (student) => (
        student?.classId && typeof student.classId === 'object' ? student.classId.className : ''
    );

    const getStudentSectionName = (student) => (
        student?.sectionId && typeof student.sectionId === 'object' && student.sectionId.sectionName
            ? String(student.sectionId.sectionName)
            : ''
    );

    const studentExportRows = useMemo(
        () => filteredStudents.map((student) => ({
            'Admission Number': student.admissionNumber || '',
            'Student ID': student.studentAutoGenerateId || '',
            'First Name': student.firstName || '',
            'Middle Name': student.middleName || '',
            'Last Name': student.lastName || '',
            'Gender': student.gender || '',
            'Date Of Birth': student.dob
                ? new Date(student.dob).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
                : '',
            'Mother Name': student.motherName || '',
            'Father Name': student.fatherName || '',
            'Mother Email': student.motherEmail || '',
            'Father Email': student.fatherEmail || '',
            'Parent Mobile': student.mobileNumber ? String(student.mobileNumber) : '',
            'Secondary Mobile': student.fatherMobileNumber ? String(student.fatherMobileNumber) : '',
            'Class': getStudentClassName(student),
            'Section': getStudentSectionName(student),
            'User Name': student.userId?.serialNumber || '',
            'Parent Profile': student.parentProfilePending ? 'Pending' : 'Complete',
            'Aadhaar Number': getStudentAadharNo(student) === '—' ? '' : getStudentAadharNo(student),
            'Address': student.address || '',
            'Allergies':
                student.allergies && String(student.allergies).trim() && String(student.allergies).toLowerCase() !== 'no'
                    ? String(student.allergies)
                    : 'No',
            'Special Needs': student.specialNeeds || '',
            'Credentials Sent': student.parentCredentialsSent ? 'Yes' : 'No',
        })),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [filteredStudents],
    );

    const studentExportFileName = useMemo(() => {
        const classLabel = uploadClassId
            ? (addClassList.find((c) => c._id === uploadClassId)?.className || 'Class')
            : 'All Classes';
        const sectionLabel = uploadSectionId
            ? (uploadSectionList.find((s) => s._id === uploadSectionId)?.sectionName || 'Section')
            : '';
        const searchLabel = searchTerm.trim() ? ' - Search' : '';
        return `Student Details - ${classLabel}${sectionLabel ? ` - ${sectionLabel}` : ''}${searchLabel}`;
    }, [uploadClassId, uploadSectionId, addClassList, uploadSectionList, searchTerm]);

    const pendingCredentialStudents = useMemo(
        () => filteredStudents.filter((student) => !student?.parentCredentialsSent),
        [filteredStudents]
    );

    const canSendParentCredentials = pendingCredentialStudents.length > 0;

    const openView = (student) => {
        setViewStudent(student || null);
        setViewOpen(true);
    };

    const closeView = () => {
        setViewOpen(false);
        setViewStudent(null);
    };

    const dateAndTime = (date) => {

        const systemDate = new Date(date);
        const formattedDateTime = systemDate.toLocaleString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            // hour: 'numeric',
            // minute: 'numeric',
            // second: 'numeric',
            // hour12: true,

        });
        return formattedDateTime;
    }
    const handleClose = () => {
        setOpen(false);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };
    const groupByStudentId = (data) => {
        return data.reduce((acc, item) => {
            const studentId = item.studentId._id;
            if (!acc[studentId]) {
                acc[studentId] = {
                    studentDetails: {
                        _id: studentId,
                        firstName: item.studentId.firstName,
                        lastName: item.studentId.lastName,
                    },
                    activities: [],
                };
            }
            acc[studentId].activities.push(item);
            return acc;
        }, {});
    };
    // const getTeacherList = () => {
    //     TeacherService.getAllTeacher().then((res) => {
    //         setTeacherList(res);
    //     }).catch((err) => {

    //     });
    // }
    const getUserPermitionsList = () => {
        const userPermitions = ActivityService.userPermitions();

        setUserPermitionsList(userPermitions);
    }
    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            if (userDetails.role === "TEACHER") {
                res = res.filter(res => res._id === userDetails.classId);
            }
            setAddClassList(res);
            if (res.length > 0) {
                setClassId(res[0]._id);
                setUploadClassId(res[0]._id);
            }

        }).catch((err) => {
            // setError(err.message);
        });
    }

    const getStudentList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        StudentService.getAllStudent(userDetails.schooleId).then((res) => {
            const mapResult = res.map((student) => {
                return { ...student, fullName: `${student.firstName} ${student.lastName} ` }
            })
            setStudentList(mapResult);
        }).catch((err) => {
            console.error("Error fetching student list:", err);
        });
    };
    // const getStudentList = (event, obj) => {
    //     const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    //     const getStuList = {  classId:event.target.value}; 


    //     StudentService.getAllStudentById(userDetails.schooleId, getStuList
    //     ).then((res) => {

    //         const studentDetails = res.map(res => {
    //             return { _id: res._id, studentName: `${res.firstName} ${res.lastName}` };
    //         });

    //         setStudentList(studentDetails);


    //     }).catch((err) => {
    //         // setError(err.message);
    //     });
    // }

    // const editActivityTabel = (tabel) => {
    //     const obj = JSON.parse(JSON.stringify(tabel));
    //     obj.superActivityId = tabel.superActivityId ? tabel.superActivityId._id : '';
    //     obj.classId = tabel.classId ? tabel.classId._id :'';
    //     // obj.activityId = sub.activityId ? sub.activityId._id : '';
    //     setTabel(obj)
    //     handleOpen()
    // }

    const editStudent = (id, student) => {

        const obj = JSON.parse(JSON.stringify(student));
        obj.classId =
            student?.classId
                ? (typeof student.classId === 'object' ? (student.classId?._id || '') : String(student.classId))
                : '';
        obj.sectionId =
            student?.sectionId
                ? (typeof student.sectionId === 'object' ? (student.sectionId?._id || '') : String(student.sectionId))
                : '';

        props.history.push({
            pathname: `/app/studentregistration/${id}`,
            state: { profileFillMode: 'parent' },
        });
        setStudent(obj);
        // handleOpen();
        setIsEditMode(true)
        setEditId(editId ? null : 1)


    }
    const deleteStudent = (studentdelete) => {
        if (!studentdelete) return;
        const studentId = typeof studentdelete === 'object' ? studentdelete._id : studentdelete;
        const studentName = typeof studentdelete === 'object' && studentdelete
            ? `${studentdelete.firstName || ''} ${studentdelete.lastName || ''}`.trim() || 'this student'
            : 'this student';
        const confirmMessage = `Are you sure you want to delete "${studentName}"?\n\nThis action cannot be undone. All associated data will be permanently removed.`;
        if (window.confirm(confirmMessage)) {
            StudentService.deleteStudent(studentId).then((res) => {
                fetchFilteredStudents();
                alert(`Student "${studentName}" has been deleted successfully.`);
            }).catch((err) => {
                alert(err?.response?.data?.message || `Failed to delete student "${studentName}". Please try again.`);
            });
        }
    };
    const sendCredentialsToParents = async () => {
        if (sendingCredentialsBulk || !pendingCredentialStudents.length) return;

        const count = pendingCredentialStudents.length;
        const confirmed = window.confirm(
            `Send login credentials email to parent(s) for ${count} student${count === 1 ? '' : 's'}?`
        );
        if (!confirmed) return;

        setSendingCredentialsBulk(true);
        let successCount = 0;
        const successIds = new Set();
        const successNames = [];
        const failures = [];

        for (const studentRow of pendingCredentialStudents) {
            const studentName = `${studentRow.firstName || ''} ${studentRow.lastName || ''}`.trim() || 'Student';
            try {
                await StudentService.sendParentCredentials(studentRow._id);
                successCount += 1;
                successIds.add(studentRow._id);
                successNames.push(studentName);
            } catch (err) {
                failures.push({
                    name: studentName,
                    message: err?.response?.data?.message || 'Failed to send email.',
                });
            }
        }

        if (successIds.size > 0) {
            setStudentList((prev) =>
                prev.map((s) =>
                    successIds.has(s._id)
                        ? {
                            ...s,
                            parentCredentialsSent: true,
                            userId: s.userId
                                ? { ...s.userId, parentSend: true }
                                : s.userId,
                        }
                        : s
                )
            );
        }

        setSendingCredentialsBulk(false);

        if (successCount === 0) {
            alert(
                failures.length
                    ? `Failed to send credentials.\n${failures[0].name}: ${failures[0].message}`
                    : 'Failed to send login credentials.'
            );
            return;
        }

        setCredentialsSuccessNames(successNames);
        setCredentialsFailureDetails(failures);
        setCredentialsSuccessOpen(true);
    };

    const openResetPasswordDialog = (studentRow) => {
        if (!studentRow?._id) return;
        setResetPasswordStudent(studentRow);
        setResetPasswordValue('');
        setResetPasswordConfirm('');
        setResetPasswordError('');
        setResetPasswordSuccess('');
        setResetShowPassword(false);
        setSendPasswordToParent(false);
        setResetPasswordOpen(true);
    };

    const closeResetPasswordDialog = () => {
        if (resetPasswordSaving) return;
        setResetPasswordOpen(false);
        setResetPasswordStudent(null);
        setResetPasswordValue('');
        setResetPasswordConfirm('');
        setResetPasswordError('');
        setResetPasswordSuccess('');
        setResetShowPassword(false);
        setSendPasswordToParent(false);
    };

    const handleResetPasswordSubmit = async () => {
        if (!resetPasswordStudent?._id || resetPasswordSaving) return;

        const password = resetPasswordValue.trim();
        const confirm = resetPasswordConfirm.trim();

        if (password.length < 6) {
            setResetPasswordError('Password must be at least 6 characters.');
            return;
        }
        if (password !== confirm) {
            setResetPasswordError('Password and confirmation do not match.');
            return;
        }

        setResetPasswordSaving(true);
        setResetPasswordError('');

        try {
            const res = await StudentService.resetParentPassword(resetPasswordStudent._id, {
                password,
                sendPasswordToParent,
            });
            const studentName = `${resetPasswordStudent.firstName || ''} ${resetPasswordStudent.lastName || ''}`.trim() || 'Student';
            setResetPasswordSuccess(
                res?.message || `Parent login password reset successfully for "${studentName}".`
            );
        } catch (err) {
            setResetPasswordError(
                err?.response?.data?.message || 'Failed to reset password. Please try again.'
            );
        } finally {
            setResetPasswordSaving(false);
        }
    };

    const deleteAllStudents = async () => {
        if (!studentList.length) {
            alert('There are no students to delete.');
            return;
        }
        const firstConfirm = window.confirm(
            'Are you sure you want to delete ALL student records shown in this list?\n\nThis operation cannot be undone.'
        );
        if (!firstConfirm) return;

        const secondConfirm = window.confirm(
            'FINAL CONFIRMATION:\n\nThis will permanently delete ALL student records for this school from the system.\n\nClick OK to proceed, or Cancel to abort.'
        );
        if (!secondConfirm) return;

        setIsDeleting(true);
        try {
            const ids = studentList
                .map((s) => (typeof s === 'object' ? s._id : s))
                .filter(Boolean);

            await StudentService.deleteAllStudents({ studentIds: ids });
            alert('All student records have been deleted successfully.');
            setStudentList([]);
        } catch (err) {
            alert(
                err?.response?.data?.message ||
                'Failed to delete all students. Some records may still remain. Please try again.'
            );
            fetchFilteredStudents();
        } finally {
            setIsDeleting(false);
        }
    };
    const formik = useFormik({
        initialValues: student,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            //   StudentService.upadeStudent(values).then((res) => {
            //     alert(" Updated Successfully.");
            //   })
            //     .catch((err) => {
            //       alert(err.response.data.message)
            //     })
        },
    });

    return (
        <>
            {/* Page header */}
            <Box className={classes.pageHeader}>
                <Box>
                    <Typography className={classes.pageTitle}>Student Details</Typography>
                    <Typography className={classes.pageSubtitle}>
                        Manage student records, search, and bulk import.
                    </Typography>
                </Box>
                <Box display="flex" alignItems="center" gridGap={10} flexWrap="wrap">
                    {String((JSON.parse(localStorage.getItem("userDetail") || "{}") || {})?.role || "").toUpperCase() === "SCHOOLE" ? (
                        <Button
                            className={classes.darkBtn}
                            variant="contained"
                            onClick={() => props.history.push("/app/upgrade-plan")}
                        >
                            Upgrade Plan
                        </Button>
                    ) : null}
                    <Tooltip
                        title={
                            canSendParentCredentials
                                ? `Send credentials to ${pendingCredentialStudents.length} student${pendingCredentialStudents.length === 1 ? '' : 's'}`
                                : 'All students in this list have already received credentials'
                        }
                    >
                        <span>
                            <Button
                                variant="outlined"
                                startIcon={sendingCredentialsBulk ? <CircularProgress size={18} /> : <SendIcon />}
                                onClick={sendCredentialsToParents}
                                disabled={sendingCredentialsBulk || !canSendParentCredentials}
                                style={{
                                    textTransform: 'none',
                                    color: canSendParentCredentials ? '#1769d6' : '#9aa6b6',
                                    borderColor: canSendParentCredentials ? '#1769d6' : '#d9dee7',
                                    fontWeight: 600,
                                }}
                            >
                                {sendingCredentialsBulk
                                    ? 'Sending…'
                                    : `Send Credentials to Parent${pendingCredentialStudents.length > 0 ? ` (${pendingCredentialStudents.length})` : ''}`}
                            </Button>
                        </span>
                    </Tooltip>
                    <Button
                        className={classes.primaryBtn}
                        variant="contained"
                        startIcon={<PersonAddIcon />}
                        onClick={handleOpen}
                    >
                        Student Registration
                    </Button>
                </Box>
            </Box>

            {/* Dismissible note */}
            {noteOpen && (
                <Box className={classes.noteBanner}>
                    <span className={classes.noteIconWrap}>
                        <InfoOutlinedIcon style={{ fontSize: 18 }} />
                    </span>
                    <Box flex={1}>
                        <Typography variant="subtitle2" style={{ fontWeight: 700, color: '#0f2d4d' }}>Note</Typography>
                        <Typography variant="body2" style={{ color: '#46566b' }}>
                            Section is optional for both search and Excel upload.
                        </Typography>
                    </Box>
                    <IconButton size="small" onClick={() => setNoteOpen(false)} aria-label="dismiss note">
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>
            )}
            {/* Filters card */}
            <Card className={classes.filtersCard} elevation={0}>
                <Box className={classes.filtersTopRow}>
                    <Box
                        className={classes.filtersChip}
                        onClick={() => setFiltersOpen((o) => !o)}
                        role="button"
                        tabIndex={0}
                    >
                        <FilterListIcon fontSize="small" />
                        <span>Filters</span>
                        <span className={classes.countBadge}>{activeFilterCount}</span>
                        {filtersOpen ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
                    </Box>
                </Box>

                <Collapse in={filtersOpen}>
                    <Box mt={2}>
                        <Grid container spacing={2} alignItems="flex-end">
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <Typography className={classes.fieldLabel}>
                                    <SchoolIcon style={{ fontSize: 16 }} /> Class
                                </Typography>
                                <FormControl fullWidth variant="outlined" size="small">
                                    <Select
                                        displayEmpty
                                        value={uploadClassId}
                                        onChange={(e) => {
                                            setUploadSectionId('');
                                            setUploadClassId(e.target.value);
                                        }}
                                    >
                                        <MenuItem value=""><em>All Classes</em></MenuItem>
                                        {addClassList.map((c) => (
                                            <MenuItem key={c._id} value={c._id}>{c.className}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <Typography className={classes.fieldLabel}>
                                    <PersonIcon style={{ fontSize: 16 }} /> Section
                                </Typography>
                                <FormControl fullWidth variant="outlined" size="small" disabled={!uploadClassId || uploadSectionList.length === 0}>
                                    <Select
                                        displayEmpty
                                        value={uploadSectionId}
                                        onChange={(e) => setUploadSectionId(e.target.value)}
                                    >
                                        <MenuItem value=""><em>All Sections</em></MenuItem>
                                        {uploadSectionList.map((s) => (
                                            <MenuItem key={s._id} value={s._id}>{s.sectionName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={6}>
                                <Box display="flex" gridGap={10} justifyContent="flex-end" flexWrap="wrap">
                                    <Button className={classes.resetBtn} variant="outlined" onClick={handleResetFilters}>
                                        Reset
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>

                        <Divider style={{ margin: '16px 0' }} />

                        {/* Bulk import */}
                        <Typography className={classes.fieldLabel} style={{ marginBottom: 8 }}>
                            <CloudUploadIcon style={{ fontSize: 16 }} /> Bulk Import (Excel)
                        </Typography>
                        <Box className={classes.uploadBox}>
                            <input ref={fileInputRef} type="file" onChange={handleFileChangeFile} accept=".xlsx,.xls" />
                            <Button
                                className={classes.darkBtn}
                                variant="contained"
                                startIcon={!isUploading ? <CloudUploadIcon /> : null}
                                onClick={handleFileUpload}
                                disabled={isUploading}
                            >
                                {isUploading ? (
                                    <>
                                        Uploading...
                                        <CircularProgress size={16} style={{ marginLeft: 8, color: 'white' }} />
                                    </>
                                ) : (
                                    'Upload Excel'
                                )}
                            </Button>
                            <a
                                className={classes.sampleLink}
                                href="https://artistimages.blob.core.windows.net/montestory/student registration sample excel (10).xlsx"
                                download="Sample.xlsx"
                            >
                                <GetAppIcon style={{ fontSize: 16 }} /> Download Sample Format
                            </a>
                        </Box>
                        {message && (
                            <Typography variant="body2" style={{ color: '#c62828', marginTop: 8 }}>{message}</Typography>
                        )}
                    </Box>
                </Collapse>
            </Card>

            {/* Table card */}
            <Card className={classes.tableCard} elevation={0}>
                <Box className={classes.toolbar}>
                    <Typography variant="body2" style={{ color: '#46566b', fontWeight: 600 }}>
                        {filteredStudents.length} {filteredStudents.length === 1 ? 'Student' : 'Students'}
                    </Typography>
                    <Box display="flex" alignItems="center" gridGap={10} flexWrap="wrap">
                        <TextField
                            size="small"
                            variant="outlined"
                            placeholder="Search by name or admission no..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ minWidth: 260 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon fontSize="small" style={{ color: '#9aa6b6' }} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Button
                            variant="outlined"
                            startIcon={<ViewColumnIcon />}
                            onClick={(e) => setColumnMenuAnchor(e.currentTarget)}
                            style={{ textTransform: 'none', color: '#46566b', borderColor: '#d9dee7' }}
                        >
                            Column
                        </Button>
                        <Tooltip title="Refresh">
                            <IconButton className={classes.iconBtnOutlined} onClick={fetchFilteredStudents}>
                                <RefreshIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={filteredStudents.length ? `Export ${filteredStudents.length} student(s)` : 'No students to export'}>
                            <span>
                                {filteredStudents.length > 0 ? (
                                    <ExportExcel
                                        excelData={studentExportRows}
                                        fileName={studentExportFileName}
                                    />
                                ) : (
                                    <Button
                                        variant="contained"
                                        disabled
                                        style={{ fontSize: 13, backgroundColor: '#94a3b8', color: '#fff' }}
                                    >
                                        Excel Export
                                    </Button>
                                )}
                            </span>
                        </Tooltip>
                    </Box>
                </Box>

                <TableContainer component={Paper} elevation={0} style={{ maxHeight: 540 }}>
                    <Table stickyHeader className="mb-0 dashboard-table-row-hover">
                        <TableHead>
                            <TableRow>
                                <TableCell style={headerCellStyle}>Profile</TableCell>
                                {visibleCols.admissionNumber && <TableCell style={headerCellStyle}>Admission Number</TableCell>}
                                <TableCell style={headerCellStyle}>First Name</TableCell>
                                {visibleCols.middleName && <TableCell style={headerCellStyle}>Middle Name</TableCell>}
                                <TableCell style={headerCellStyle}>Last Name</TableCell>
                                {visibleCols.parentMobile && <TableCell style={headerCellStyle}>Parent Mobile</TableCell>}
                                {visibleCols.className && <TableCell style={headerCellStyle}>Class</TableCell>}
                                {visibleCols.section && <TableCell style={headerCellStyle}>Section</TableCell>}
                                {visibleCols.userName && <TableCell style={headerCellStyle}>User Name</TableCell>}
                                {visibleCols.parentProfileStatus && (
                                    <TableCell style={headerCellStyle}>Parent Profile</TableCell>
                                )}
                                {visibleCols.aadharNumber && (
                                    <TableCell style={headerCellStyle}>Aadhaar Number</TableCell>
                                )}
                                {visibleCols.address && <TableCell style={headerCellStyle}>Address</TableCell>}
                                <TableCell style={headerCellStyle} align="center">Actions</TableCell>
                                {canResetParentPassword && (
                                    <TableCell style={headerCellStyle} align="center">Reset Password</TableCell>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredStudents.slice(pg * rpg, pg * rpg + rpg).map((student) => {
                                const className = student.classId && typeof student.classId === 'object' ? student.classId.className : '';
                                const sectionName = (student.sectionId && typeof student.sectionId === 'object' && student.sectionId.sectionName)
                                    ? String(student.sectionId.sectionName) : '';
                                return (
                                    <TableRow key={student._id}>
                                        <TableCell>
                                            <Avatar
                                                src={student.profileURL || student.imageURL?.[0] || undefined}
                                                className={classes.studentAvatar}
                                            >
                                                {(student.firstName || '?').charAt(0).toUpperCase()}
                                            </Avatar>
                                        </TableCell>
                                        {visibleCols.admissionNumber && (
                                            <TableCell>{student.admissionNumber || '—'}</TableCell>
                                        )}
                                        <TableCell style={{ fontWeight: 600, color: '#0f2d4d' }}>{student.firstName}</TableCell>
                                        {visibleCols.middleName && (
                                            <TableCell>{student.middleName ? String(student.middleName) : '—'}</TableCell>
                                        )}
                                        <TableCell>{student.lastName}</TableCell>
                                        {visibleCols.parentMobile && (
                                            <TableCell>{student.mobileNumber ? String(student.mobileNumber) : '—'}</TableCell>
                                        )}
                                        {visibleCols.className && (
                                            <TableCell>
                                                {className ? <Chip size="small" label={className} className={classes.classChip} /> : '—'}
                                            </TableCell>
                                        )}
                                        {visibleCols.section && (
                                            <TableCell>
                                                {sectionName ? <Chip size="small" label={sectionName} className={classes.sectionChip} /> : '—'}
                                            </TableCell>
                                        )}
                                        {visibleCols.userName && (
                                            <TableCell>{student.userId?.serialNumber || '—'}</TableCell>
                                        )}
                                        {visibleCols.parentProfileStatus && (
                                            <TableCell>
                                                {student.parentProfilePending ? (
                                                    <Chip size="small" label="Pending" style={{ backgroundColor: '#fff4e5', color: '#b45309', fontWeight: 600 }} />
                                                ) : (
                                                    <Chip size="small" label="Complete" style={{ backgroundColor: '#e8f8ef', color: '#15803d', fontWeight: 600 }} />
                                                )}
                                            </TableCell>
                                        )}
                                        {visibleCols.aadharNumber && (
                                            <TableCell>{getStudentAadharNo(student)}</TableCell>
                                        )}
                                        {visibleCols.address && (
                                            <TableCell>{student.address ? String(student.address) : '—'}</TableCell>
                                        )}
                                        <TableCell align="center">
                                            <IconButton size="small" onClick={(e) => openActionMenu(e, student)}>
                                                <MoreVertIcon fontSize="small" />
                                            </IconButton>
                                        </TableCell>
                                        {canResetParentPassword && (
                                            <TableCell align="center">
                                                <Tooltip title="Reset parent login password">
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => openResetPasswordDialog(student)}
                                                        style={{ color: '#1769d6' }}
                                                    >
                                                        <VpnKeyIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        )}
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    component="div"
                    rowsPerPageOptions={[1000, 50000, 100000]}
                    count={filteredStudents.length}
                    page={pg}
                    onPageChange={handleChangePage}
                    rowsPerPage={rpg}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Card>

            {/* Column visibility menu */}
            <Menu
                anchorEl={columnMenuAnchor}
                open={Boolean(columnMenuAnchor)}
                onClose={() => setColumnMenuAnchor(null)}
            >
                {columnConfig.map((col) => (
                    <MenuItem
                        key={col.id}
                        onClick={() => setVisibleCols((v) => ({ ...v, [col.id]: !v[col.id] }))}
                    >
                        <Checkbox checked={visibleCols[col.id]} size="small" color="primary" />
                        {col.label}
                    </MenuItem>
                ))}
            </Menu>

            {/* Row actions menu */}
            <Menu
                anchorEl={actionMenu.anchorEl}
                open={Boolean(actionMenu.anchorEl)}
                onClose={closeActionMenu}
            >
                <MenuItem onClick={() => { openView(actionMenu.student); closeActionMenu(); }}>
                    <VisibilityIcon fontSize="small" style={{ marginRight: 10, color: '#46566b' }} /> View
                </MenuItem>
                {addUserPermitionsList?.studentDetailsEdit && (
                    <MenuItem onClick={() => { editStudent(actionMenu.student?._id, actionMenu.student); closeActionMenu(); }}>
                        <EditIcon fontSize="small" style={{ marginRight: 10, color: '#46566b' }} /> Edit
                    </MenuItem>
                )}
                {addUserPermitionsList?.studentDetailsDelete && (
                    <MenuItem onClick={() => { deleteStudent(actionMenu.student); closeActionMenu(); }} style={{ color: '#dc3545' }}>
                        <DeleteIcon fontSize="small" style={{ marginRight: 10 }} /> Delete
                    </MenuItem>
                )}
            </Menu>

            {/* View student details popup */}
            <Dialog open={viewOpen} onClose={closeView} fullWidth maxWidth="sm">
                <DialogTitle>Student Details</DialogTitle>
                <DialogContent dividers>
                    {viewStudent ? (
                        <Box display="flex" flexDirection="column" py={1} style={{ gap: 10 }}>
                            <Typography variant="h6" style={{ fontWeight: 900 }}>
                                {`${viewStudent.firstName || ""} ${viewStudent.middleName || ""} ${viewStudent.lastName || ""}`.replace(/\s+/g, " ").trim()}
                            </Typography>

                            <Typography variant="body2"><b>Gender:</b> {viewStudent.gender ? String(viewStudent.gender) : "—"}</Typography>
                            <Typography variant="body2"><b>Mother Name:</b> {viewStudent.motherName ? String(viewStudent.motherName) : "—"}</Typography>
                            <Typography variant="body2"><b>Father Name:</b> {viewStudent.fatherName ? String(viewStudent.fatherName) : "—"}</Typography>
                            <Typography variant="body2"><b>Mother Gmail / Email:</b> {viewStudent.motherEmail ? String(viewStudent.motherEmail) : "—"}</Typography>
                            <Typography variant="body2"><b>Father Gmail / Email:</b> {viewStudent.fatherEmail ? String(viewStudent.fatherEmail) : "—"}</Typography>
                            <Typography variant="body2"><b>Date Of Birth:</b> {viewStudent.dob ? dateAndTime(viewStudent.dob) : "—"}</Typography>
                            <Typography variant="body2"><b>Allergies:</b> {viewStudent.allergies && String(viewStudent.allergies).trim() && String(viewStudent.allergies).toLowerCase() !== 'no' ? String(viewStudent.allergies) : "No"}</Typography>
                            <Typography variant="body2"><b>Special Needs:</b> {viewStudent.specialNeeds ? String(viewStudent.specialNeeds) : "—"}</Typography>
                            <Typography variant="body2"><b>Aadhaar Number:</b> {getStudentAadharNo(viewStudent)}</Typography>
                            <Typography variant="body2"><b>Address:</b> {viewStudent.address ? String(viewStudent.address) : "—"}</Typography>
                            <Typography variant="body2">
                                <b>Parent Profile:</b>{" "}
                                {viewStudent.parentProfilePending ? "Pending (parent has not completed profile)" : "Complete"}
                            </Typography>

                            <Box mt={1}>
                                <Typography variant="body2" style={{ fontWeight: 900, marginBottom: 6 }}>Authorized Pickup(s)</Typography>
                                {Array.isArray(viewStudent.authorizedPickups) && viewStudent.authorizedPickups.length > 0 ? (
                                    <Box display="flex" flexDirection="column" style={{ gap: 6 }}>
                                        {viewStudent.authorizedPickups.map((p, idx) => (
                                            <Typography key={`pickup-${idx}`} variant="body2">
                                                {p?.name ? String(p.name) : "—"}{p?.mobileNumber ? ` — ${String(p.mobileNumber)}` : ""}
                                            </Typography>
                                        ))}
                                    </Box>
                                ) : (
                                    <Typography variant="body2" style={{ color: "#6b7280" }}>
                                        {viewStudent.authorizedPickupName || viewStudent.authorizedPickupMobileNumber
                                            ? `${viewStudent.authorizedPickupName ? String(viewStudent.authorizedPickupName) : '—'}${viewStudent.authorizedPickupMobileNumber ? ` — ${String(viewStudent.authorizedPickupMobileNumber)}` : ''}`
                                            : "—"}
                                    </Typography>
                                )}
                            </Box>

                            <Box mt={1}>
                                <Typography variant="body2" style={{ fontWeight: 900, marginBottom: 6 }}>Documents</Typography>
                                <Typography variant="body2">
                                    <b>Aadhaar Card:</b>{" "}
                                    {Array.isArray(viewStudent.imageURL) && viewStudent.imageURL.length > 0 ? (
                                        <a href={viewStudent.imageURL[0]} target="_blank" rel="noreferrer">View</a>
                                    ) : (
                                        "—"
                                    )}
                                </Typography>
                                <Typography variant="body2">
                                    <b>Birth Certificate:</b>{" "}
                                    {viewStudent.birthCertificateURL ? (
                                        <a href={viewStudent.birthCertificateURL} target="_blank" rel="noreferrer">View</a>
                                    ) : (
                                        "—"
                                    )}
                                </Typography>
                            </Box>
                        </Box>
                    ) : (
                        <Typography variant="body2" style={{ color: "#6b7280" }}>No student selected.</Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeView} color="primary">Close</Button>
                </DialogActions>
            </Dialog>

            {/* Sending parent credentials */}
            <Dialog
                open={sendingCredentialsBulk}
                disableBackdropClick
                disableEscapeKeyDown
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>Sending login credentials…</DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column" alignItems="center" py={2}>
                        <CircularProgress size={48} style={{ marginBottom: 16 }} />
                        <Typography variant="body1" align="center" gutterBottom>
                            Please wait while login credentials are sent to parents.
                        </Typography>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Email sent success */}
            <Dialog
                open={credentialsSuccessOpen}
                onClose={() => setCredentialsSuccessOpen(false)}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle style={{ fontWeight: 700, color: '#1a9b54' }}>Mail sent successfully</DialogTitle>
                <DialogContent dividers>
                    <Box display="flex" flexDirection="column" alignItems="center" py={1}>
                        <CheckCircleIcon style={{ fontSize: 56, color: '#1a9b54', marginBottom: 16 }} />
                        <Typography variant="body1" align="center" style={{ color: '#46566b', fontWeight: 600, marginBottom: 12 }}>
                            Mail sent successfully to {credentialsSuccessNames.length} student parent{credentialsSuccessNames.length === 1 ? '' : 's'}:
                        </Typography>
                        <Box
                            width="100%"
                            style={{
                                maxHeight: 220,
                                overflowY: 'auto',
                                padding: '12px 14px',
                                borderRadius: 10,
                                backgroundColor: '#e6f7ed',
                                border: '1px solid #b7e4c7',
                            }}
                        >
                            {credentialsSuccessNames.map((name, index) => (
                                <Typography
                                    key={`success-${index}`}
                                    variant="body2"
                                    style={{ color: '#1a5c36', lineHeight: 1.7 }}
                                >
                                    {index + 1}. {name}
                                </Typography>
                            ))}
                        </Box>
                        {credentialsFailureDetails.length > 0 && (
                            <Box width="100%" mt={2}>
                                <Typography variant="body2" style={{ color: '#dc3545', fontWeight: 600, marginBottom: 8 }}>
                                    Failed for {credentialsFailureDetails.length} student{credentialsFailureDetails.length === 1 ? '' : 's'}:
                                </Typography>
                                <Box
                                    style={{
                                        maxHeight: 160,
                                        overflowY: 'auto',
                                        padding: '12px 14px',
                                        borderRadius: 10,
                                        backgroundColor: '#fff5f5',
                                        border: '1px solid #f5c2c7',
                                    }}
                                >
                                    {credentialsFailureDetails.map((item, index) => (
                                        <Typography
                                            key={`failure-${index}`}
                                            variant="body2"
                                            style={{ color: '#842029', lineHeight: 1.7 }}
                                        >
                                            {index + 1}. {item.name}
                                        </Typography>
                                    ))}
                                </Box>
                            </Box>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setCredentialsSuccessOpen(false);
                            setCredentialsSuccessNames([]);
                            setCredentialsFailureDetails([]);
                        }}
                        color="primary"
                        variant="contained"
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Reset parent password */}
            <Dialog
                open={resetPasswordOpen}
                onClose={closeResetPasswordDialog}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle style={{ fontWeight: 700, color: '#0f2d4d' }}>Reset Password</DialogTitle>
                <DialogContent dividers>
                    {resetPasswordSuccess ? (
                        <Box
                            style={{
                                padding: 16,
                                backgroundColor: '#e6f7ed',
                                borderRadius: 10,
                                border: '1px solid #b7e4c7',
                            }}
                        >
                            <Typography variant="body2" style={{ color: '#1a9b54', fontWeight: 600, lineHeight: 1.6 }}>
                                {resetPasswordSuccess}
                            </Typography>
                        </Box>
                    ) : (
                        <>
                            {resetPasswordStudent && (
                                <Typography variant="body2" style={{ marginBottom: 16, color: '#46566b' }}>
                                    Set a new parent login password for{' '}
                                    <strong>
                                        {`${resetPasswordStudent.firstName || ''} ${resetPasswordStudent.lastName || ''}`.trim() || 'this student'}
                                    </strong>
                                    . Parents sign in with their <strong>User Name</strong> and this password.
                                </Typography>
                            )}
                            <span className={classes.fieldLabel}>New Password</span>
                            <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                autoComplete="new-password"
                                type={resetShowPassword ? 'text' : 'password'}
                                value={resetPasswordValue}
                                onChange={(e) => {
                                    setResetPasswordValue(e.target.value);
                                    if (resetPasswordError) setResetPasswordError('');
                                }}
                                error={Boolean(resetPasswordError)}
                                placeholder="Enter new password"
                                style={{ marginBottom: 12 }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                size="small"
                                                onClick={() => setResetShowPassword((prev) => !prev)}
                                                edge="end"
                                            >
                                                {resetShowPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <span className={classes.fieldLabel}>Confirm Password</span>
                            <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                autoComplete="new-password"
                                type={resetShowPassword ? 'text' : 'password'}
                                value={resetPasswordConfirm}
                                onChange={(e) => {
                                    setResetPasswordConfirm(e.target.value);
                                    if (resetPasswordError) setResetPasswordError('');
                                }}
                                error={Boolean(resetPasswordError)}
                                helperText={resetPasswordError || 'Minimum 6 characters'}
                                placeholder="Confirm new password"
                            />
                            <FormControlLabel
                                style={{ marginTop: 12 }}
                                control={
                                    <Checkbox
                                        color="primary"
                                        checked={sendPasswordToParent}
                                        onChange={(e) => setSendPasswordToParent(e.target.checked)}
                                    />
                                }
                                label={
                                    <Typography variant="body2" style={{ color: '#46566b' }}>
                                        Send password to the parent (email to registered Parent-1 / Parent-2 addresses)
                                    </Typography>
                                }
                            />
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    {resetPasswordSuccess ? (
                        <Button onClick={closeResetPasswordDialog} color="primary" variant="contained">
                            Close
                        </Button>
                    ) : (
                        <>
                            <Button onClick={closeResetPasswordDialog} disabled={resetPasswordSaving}>
                                Cancel
                            </Button>
                            <Button
                                onClick={handleResetPasswordSubmit}
                                color="primary"
                                variant="contained"
                                disabled={!resetPasswordValue.trim() || !resetPasswordConfirm.trim() || resetPasswordSaving}
                                startIcon={<VpnKeyIcon />}
                            >
                                {resetPasswordSaving ? 'Updating…' : 'Update Password'}
                            </Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>

            {/* Upload in progress – do not close until upload finishes */}
            <Dialog
                open={isUploading}
                disableBackdropClick
                disableEscapeKeyDown
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>Uploading data...</DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column" alignItems="center" py={2}>
                        <CircularProgress size={48} style={{ marginBottom: 16 }} />
                        <Typography variant="body1" align="center" gutterBottom>
                            Please wait until all data is uploaded.
                        </Typography>
                        
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Deleting students – do not close until delete finishes */}
            <Dialog
                open={isDeleting}
                disableBackdropClick
                disableEscapeKeyDown
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>Deleting students...</DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column" alignItems="center" py={2}>
                        <CircularProgress size={48} style={{ marginBottom: 16 }} />
                        <Typography variant="body1" align="center" gutterBottom>
                            Please wait until all students are deleted.
                        </Typography>
                       
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Upload error popup */}
            <Dialog
                open={uploadErrorOpen}
                onClose={() => setUploadErrorOpen(false)}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>Upload Error</DialogTitle>
                <DialogContent dividers>
                    {uploadError.message && (
                        <Typography variant="body1" gutterBottom>
                            {uploadError.message}
                        </Typography>
                    )}

                    {uploadError.invalidClasses && uploadError.invalidClasses.length > 0 && (
                        <div
                            style={{
                                marginTop: 12,
                                marginBottom: 12,
                                padding: '8px 12px',
                                borderRadius: 6,
                                backgroundColor: '#ffebee', // light red
                                borderLeft: '4px solid #f44336',
                            }}
                        >
                            <Typography variant="subtitle2" gutterBottom style={{ color: '#b71c1c' }}>
                                Invalid class names found in the file:
                            </Typography>
                            <ul style={{ marginTop: 0, paddingLeft: 20 }}>
                                {uploadError.invalidClasses.map((name, idx) => (
                                    <li key={`${name}-${idx}`}>
                                        <Typography variant="body2" style={{ color: '#d32f2f' }}>
                                            {name}
                                        </Typography>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {uploadError.allowedClassNames && uploadError.allowedClassNames.length > 0 && (
                        <div
                            style={{
                                marginTop: 8,
                                padding: '8px 12px',
                                borderRadius: 6,
                                backgroundColor: '#e8f5e9', // light green
                                borderLeft: '4px solid #4caf50',
                            }}
                        >
                            <Typography variant="subtitle2" gutterBottom style={{ color: '#1b5e20' }}>
                                Allowed class names:
                            </Typography>
                            <ul style={{ marginTop: 0, paddingLeft: 20 }}>
                                {uploadError.allowedClassNames.map((name, idx) => (
                                    <li key={`${name}-allowed-${idx}`}>
                                        <Typography variant="body2" style={{ color: '#2e7d32' }}>
                                            {name}
                                        </Typography>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setUploadErrorOpen(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Upload completed with failed rows – which field / error per row */}
            <Dialog
                open={uploadFailedOpen}
                onClose={() => setUploadFailedOpen(false)}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>Upload completed with errors</DialogTitle>
                <DialogContent dividers>
                    <Typography variant="body2" color="textSecondary" gutterBottom>
                        The following rows could not be imported. Check the field and error to fix your file.
                    </Typography>
                    <TableContainer component={Paper} style={{ marginTop: 12, maxHeight: 360 }}>
                        <Table size="small" stickyHeader className="dashboard-table-row-hover">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ fontWeight: 600 }}>Student name</TableCell>
                                    <TableCell style={{ fontWeight: 600 }}>Field</TableCell>
                                    <TableCell style={{ fontWeight: 600 }}>Error</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {uploadFailedDetails.map((row, idx) => (
                                    <TableRow key={`failed-${idx}`}>
                                        <TableCell>{row.name || '—'}</TableCell>
                                        <TableCell>{row.field || '—'}</TableCell>
                                        <TableCell>{row.message || '—'}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setUploadFailedOpen(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}


